import locationFromUrl from './locationFromUrl';
var createInitialRouterState = function (_a) {
    var fromJS = _a.fromJS;
    return function (url) {
        var initialState = {
            location: url
                ? locationFromUrl(url)
                : {
                    pathname: '',
                    search: '',
                    hash: '',
                    href: '',
                },
        };
        return fromJS(initialState);
    };
};
export default createInitialRouterState;
